<template>
  <el-dialog
    title="问卷列表"
    width="60%"
    :visible="dialogVisible"
    append-to-body="true"
    @close="$emit('close')">
    <avue-crud
      ref="crud"
      :page.sync="page"
      :data="tableData"
      :table-loading="tableLoading"
      :option="option"
      @current-change="currentChange"
      @size-change="sizeChange"
      @selection-change="selectionChange"
      @row-click="rowClick">

      <template slot="radio" slot-scope="{row}">
        <el-radio v-if="!disabledQuestionnaireIds.includes(row.id)" v-model="selectedQuestionnaireId" :label="row.id"></el-radio>
      </template>

      <template slot="isRelatedProject" slot-scope="{row}">
        {{ disabledQuestionnaireIds.includes(row.id) ? '是' : '否' }}
      </template>

      <template slot="name" slot-scope="{row}">
        <span class="click" @click="getQuestionnaireDetail(row.id)">{{row.name}}</span>
      </template>
      <template slot="status" slot-scope="{row}">
        {{ row.isPublish ? '已上架' : '已下架' }}
      </template>

    </avue-crud>
    <span
      class="dialog-footer"
      slot="footer"
      >
      <el-button
        @click="$emit('close')"
        >取 消</el-button>

      <el-button
        type="primary"
        @click="handleConfirmSelect"
        >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getQuestionnaireList } from '@/api/app/questionnaire'
import { formatDate } from '@/util/date'

export default {
  name: 'QuestionnaireSelector',
  props: {
    dialogVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    selectedQuestionnaires: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabledQuestionnaireIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedQuestionnaire: {},
      selectedQuestionnaireId: {},
      // statusOptions,
      tableLoading: false,
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      listQuery: {},
      option: {
        tip: false,
        border: true,
        stripe: true,
        menuAlign: 'center',
        align: 'center',
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        viewBtn: false,
        menu: false,
        column: [
          {
            label: '',
            prop: 'radio',
            width: 60,
            solt: true,
          },
          {
            label: 'ID',
            prop: 'id',
            overHidden: true,
          },
          {
            label: '名称',
            prop: 'name',
            width: 160,
            overHidden: true,
            solt: true,
          },
          {
            label: '描述',
            prop: 'description',
            overHidden: true,
          },
          {
            label: '状态',
            prop: 'status',
            solt: true,
          },
          {
            label: '已关联子项目',
            prop: 'isRelatedProject',
            solt: true,
            width: 110,
          },
          {
            label: '开始时间',
            prop: 'startTime',
            width: 160,
          },
          {
            label: '结束时间',
            prop: 'endTime',
            width: 160,
          },
        ]
      },
    }
  },
  created() {
    this.getList();
  },
  methods: {
    dateFormat(datetime) {
      return formatDate('YYYY-mm-dd HH:MM', new Date(datetime));
    },
    getQuestionnaireDetail(questionnaireId) {
      const routeData =this.$router.resolve({
        path: `/app/questionnaire/detail/${questionnaireId}`,
      });
      window.open(routeData.href,'_blank');
    },
    rowClick(row) {
      this.selectedQuestionnaire = row;
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.listQuery.current = val;
      this.getList();
    },
    sizeChange(val) {
      this.page.currentPage = 1;
      this.listQuery.current = 1;
      this.page.pageSize = val;
      this.listQuery.size = val;
      this.getList();
    },
    selectionChange(list){
      this.selectedQuestionnaires = list;
    },
    toggleSelection(val){
      this.$refs.crud.toggleSelection(val);
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach(record => {
          record.startTime = !record.startTime ? '--': this.dateFormat(record.startTime);
          record.endTime = !record.endTime ? '--': this.dateFormat(record.endTime);
        })
      }
      return records;
    },
    getList() {
      this.tableLoading = true
      getQuestionnaireList(this.listQuery).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
        const selectedQuestionnaireIds = this.selectedQuestionnaires.map(questionnaire => questionnaire.questionnaireId);
        this.selectedQuestionnaires = this.tableData.filter(questionnaire => {
          return selectedQuestionnaireIds.includes(questionnaire.id)
        });
        this.$nextTick(() => {
          this.toggleSelection(this.selectedQuestionnaires);
        });
      }).catch(error => {
        console.error(error);
        this.$message({
          message: '获取问卷列表失败',
          type: 'error'
        });
        this.tableLoading = false;
      })
    },
    handleConfirmSelect() {
      this.$emit('close')
      this.$emit('confirm-select', this.selectedQuestionnaire);
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ thead .el-checkbox {
  display: none;
}

/deep/ .el-radio__label {
  display: none;
}

/deep/ .el-radio__inner {
  border: 1px solid #58779b;
}

/deep/ .avue-crud__menu {
  display: none;
}

.click {
  color: #409eef;
  cursor: pointer;
}
</style>
